import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  error: "",
  riskLoading: false,
  pageLoading: false,
  changeRequestLoading: false,
  changeRequests: [],
  communicationPlans: [],
  communicationPlanStatusLoading: false,
  risks: [],
  riskStatusLoading: false,
  changeRequestPagination: {},
  riskPagination: {},
});

export default function changeRequestReducer(state = initialState, action) {
  switch (action.type) {
    // Change request sorting
    case ACTIONS.SORT_CHANGE_REQUEST.PENDING: {
      return state.set("error", "");
    }
    case ACTIONS.SORT_CHANGE_REQUEST.SUCCESS: {
      return state
        .set("changeRequestLoading", false)
        .set("error", "")
        .set("changeRequests", action.data.data)
        .set("changeRequestPagination", action.data.pagination);
    }
    case ACTIONS.SORT_CHANGE_REQUEST.ERROR: {
      return state
        .set("changeRequestLoading", false)
        .set("error", action.error);
    }

    // Change request lisitng
    case ACTIONS.CHANGE_REQUEST.PENDING: {
      return state.set("error", "").set("pageLoading", true);
    }
    case ACTIONS.CHANGE_REQUEST.SUCCESS: {
      return state
        .set("pageLoading", false)
        .set("error", "")
        .set("changeRequests", action.data.data)
        .set("changeRequestPagination", action.data.pagination);
    }
    case ACTIONS.CHANGE_REQUEST.ERROR: {
      return state.set("pageLoading", false).set("error", action.error);
    }

    // Create Change request
    case ACTIONS.CREATE_CHANGE_REQUEST.PENDING: {
      return state.set("changeRequestLoading", true).set("error", "");
    }
    case ACTIONS.CREATE_CHANGE_REQUEST.SUCCESS: {
      return state
        .set("changeRequestLoading", false)
        .set("error", "")
        .set("changeRequests", action.data.data)
        .set("changeRequestPagination", action.data.pagination);
    }
    case ACTIONS.CREATE_CHANGE_REQUEST.ERROR: {
      return state
        .set("error", action.error)
        .set("changeRequestLoading", false);
    }

    // Update Change request
    case ACTIONS.UPDATE_CHANGE_REQUEST.PENDING: {
      return state.set("changeRequestLoading", true).set("error", "");
    }
    case ACTIONS.UPDATE_CHANGE_REQUEST.SUCCESS: {
      return state
        .set("changeRequestLoading", false)
        .set("error", "")
        .set("changeRequests", action.data.data)
        .set("changeRequestPagination", action.data.pagination);
    }
    case ACTIONS.UPDATE_CHANGE_REQUEST.ERROR: {
      return state
        .set("error", action.error)
        .set("changeRequestLoading", false);
    }

    // Delete Change request
    case ACTIONS.DELETE_CHANGE_REQUEST.PENDING: {
      return state.set("error", "").set("changeRequestLoading", true);
    }
    case ACTIONS.DELETE_CHANGE_REQUEST.SUCCESS: {
      return state
        .set("error", "")
        .set("changeRequestLoading", false)
        .set("changeRequests", action.data.data)
        .set("changeRequestPagination", action.data.pagination);
    }
    case ACTIONS.DELETE_CHANGE_REQUEST.ERROR: {
      return state
        .set("error", action.error)
        .set("changeRequestLoading", false);
    }

    // Create Change request risk
    case ACTIONS.CREATE_CHANGE_REQUEST_RISK.PENDING: {
      return state.set("error", "").set("riskLoading", true);
    }
    case ACTIONS.CREATE_CHANGE_REQUEST_RISK.SUCCESS: {
      return state.set("error", "").set("riskLoading", false);
    }
    case ACTIONS.CREATE_CHANGE_REQUEST_RISK.ERROR: {
      return state.set("error", action.error).set("riskLoading", false);
    }

    default: {
      return state;
    }
  }
}
